import {
    DEVICES_CONTAINER,
    FILTER_PILL_CONTAINER,
    LOADING_CONTAINER,
    NOTIFICATION_CONTAINER,
    TOTAL_DEVICES_CONTAINER,
} from './constants';
import mountLoadingSpinner from '../../components/LoadingSpinner';
import {
    ACCORDION_BASE_CLASSNAME,
    createAccordion,
} from '@vfde-brix/ws10/accordion';
import mountNotification from '../../components/Notification';
import mountFilterPill from '../../components/FilterPill';
import mountProductCard from '../../components/ProductCard';
import { IProductCardProperties } from '@vfde-brix/ws10/product-card';
import { mountJustText } from '../../components/JustText';
import {
    createComponents,
    NO_PATTERN_BUSINESS_LOGIC,
} from '@vfde-brix/ws10/core';
import { getCategoriesFromUrl } from './helpers/getCategoriesFromUrl';
import { getPaymentMethod } from './helpers/getPaymentMethod';
import { useDispatch } from '../../store';
import {
    setInitialState,
    toggleAccordionItem,
} from './slice';

const mountStoneDopAppContainer = () => {
    const dispatch = useDispatch();

    createComponents(`.${ACCORDION_BASE_CLASSNAME}`, createAccordion, {
        onToggle: itemProperties => dispatch(toggleAccordionItem({
            stdId: itemProperties.stdId,
            stdHeadline: itemProperties.stdHeadline,
            optOpen: itemProperties.optOpen,
        })),
    });

    mountLoadingSpinner(LOADING_CONTAINER);
    mountNotification(NOTIFICATION_CONTAINER);
    mountFilterPill(FILTER_PILL_CONTAINER);
    mountJustText(TOTAL_DEVICES_CONTAINER);
    mountProductCard(DEVICES_CONTAINER, {
        productCardItems: [],
        business: NO_PATTERN_BUSINESS_LOGIC,
    } as IProductCardProperties);

    dispatch(setInitialState(getCategoriesFromUrl(), getPaymentMethod() || null));
};

export default mountStoneDopAppContainer;
